import * as types from "../types";
import backend from "../api/api";
import { store } from "../store";

const getConfig = () => {
  const token = store.getState().auth.token;

  const config = {
    headers: {
      Authorization: `Token ${token}`,
    },
  };

  return config;
};

export const createMenu = (formValues) => async (dispatch) => {
  try {
    const response = await backend.post(
      `api/ecommerce/menu/`,
      formValues,
      getConfig()
    );
    if (response.status === 201) {
      return response.data;
    }
  } catch (error) {
    console.log(error);
  }
};

export const getAllMenus = () => async (dispatch) => {
  try {
    const response = await backend.get(`api/ecommerce/menu/`, getConfig());
    if (response.status === 200) {
      return response.data;
    }
  } catch (error) {
    console.log(error);
  }
};

export const getSpecificMenu = (id) => async (dispatch) => {
  try {
    const response = await backend.get(
      `api/ecommerce/menu/${id}/`,
      getConfig()
    );
    if (response.status === 200) {
      return response.data;
    }
  } catch (error) {
    console.log(error);
  }
};

export const updateMenu = (id, formValues) => async (dispatch) => {
  try {
    const response = await backend.patch(
      `api/ecommerce/menu/${id}/`,
      formValues,
      getConfig()
    );
    if (response.status === 200) {
      return response.data;
    }
  } catch (error) {
    console.log(error);
  }
};

export const deleteMenu = (id) => async (dispatch) => {
  try {
    const response = await backend.delete(
      `api/ecommerce/menu/${id}/`,
      getConfig()
    );
    if (response.status === 204) {
      return true;
    }
  } catch (error) {
    console.log(error);
  }
};

export const createMenuItem = (formValues) => async (dispatch) => {
  try {
    const response = await backend.post(
      `api/ecommerce/menuitem/`,
      formValues,
      getConfig()
    );
    if (response.status === 201) {
      return response.data;
    }
  } catch (error) {
    console.log(error);
  }
};

export const updateMenuItem = (id, formValues) => async (dispatch) => {
  try {
    const response = await backend.patch(
      `api/ecommerce/menuitem/${id}/`,
      formValues,
      getConfig()
    );
    if (response.status === 200) {
      return response.data;
    }
  } catch (error) {
    console.log(error);
  }
};

export const deleteMenuItem = (id) => async (dispatch) => {
  try {
    const response = await backend.delete(
      `api/ecommerce/menuitem/${id}/`,
      getConfig()
    );
    if (response.status === 204) {
      return true;
    }
  } catch (error) {
    console.log(error);
  }
};

export const reorderMenuItems = (items) => async (dispatch) => {
  try {
    const response = await backend.post(
      `api/ecommerce/menuitem/reorder/`,
      items,
      getConfig()
    );
    if (response.status === 200) {
      return response.data;
    }
  } catch (error) {
    console.log(error);
  }
};
